module.exports = __webpack_public_path__ + "img/w3_reload_white.0515e547.png";